export function getOptionValue(option) {
    if (option && typeof option === "object") {
        return option.value;
    }
    return option;
}

export function getOptionLabel(option) {
    if (option && typeof option === "object") {
        return String(option.label ?? option.value ?? "");
    }
    return String(option ?? "");
}

export function withTranslatedLabels(options, t, keyPrefix) {
    if (!Array.isArray(options)) {
        return [];
    }

    return options.map((option) => {
        const value = getOptionValue(option);
        const fallback = getOptionLabel(option) || String(value ?? "");
        const label = t(`${keyPrefix}.${value}`, { defaultValue: fallback });

        if (option && typeof option === "object") {
            return { ...option, label };
        }

        return { value, label };
    });
}
